import _ from "lodash";

export const CompanyTypeDroOpts = (operatingUnit: string) => {

    const CC = "CC";
    const SL = "SL";
    const COD = "COD";
    const LPA = "LPA";
    const BOTH = "Both";
    const CONSIGNEE = "Consignee";
    const CONSIGNEE_SHIPPER = "Consignee and Shipper";
    const LINE = "Line";
    const SHIPPER = "Shipper";

    const getDroOptsModel_1 = () => {
        let ret: string[] = [];

        if (!(operatingUnit === "SAPT" || operatingUnit === "KICT"))
    	{
            ret.push(CC);
    	}

        ret.push(SL);
        if (!(operatingUnit === "OICT" || operatingUnit === "HPJZ"))
    	{
            ret.push(COD);
            ret.push(LPA);
    	}
        
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    const getDroOptsModel_2 = () => {
        let ret: string[] = [];   	

        ret.push(SL);
        ret.push(CC);
        ret.push(BOTH);
        
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    const getDroOptsModel_3 = () => {
        let ret: string[] = [];   	

        ret.push(CONSIGNEE);
        ret.push(CONSIGNEE_SHIPPER);
        ret.push(LINE);
        ret.push(SHIPPER);
        
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }

    return {
        getDroOptsModel_1,
        getDroOptsModel_2,
        getDroOptsModel_3
    }
}